<template>
  <div class="home">
    <!-- 头部 -->
    <Header>BasicResources基础资源管理</Header>
        <!-- 内容区 -->
    <div class="content">
        <Echarts></Echarts>
    </div>
  </div>
</template>

<script>
import Echarts from '../../components/Echarts.vue'
import Header from '../../components/Header.vue';
export default {
  components: { Echarts, Header },
  name:'BasicResources', // 基础资源管理
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 90%;
  background: rgba(39, 9, 212, 0.904); // 背景图
  header {
    width: 100%;
    height: 10%;
    background: rgba(255, 0, 0); // 头部
  }
  .content {
    width: 100%;
    height: 70%;
    background: rgba(198, 224, 47, 0.301);
  }
}
</style>